module.exports = __webpack_public_path__ + "static/media/Icon-material-location.10123e3f.svg";